'use strict';

import React from 'react';

import { OnSchedUtils } from "../../../utils";


const SubmitRow = ({ cancel, height, width, element }) => {
  return (
    <div className="SubmitRow">
      { cancel && 
        <button 
          type="button" 
          className='OnSchedBtn onsched-shadow-background-color onsched-dark-color onsched-primary-color-hover' 
          onClick={cancel}
        >
          {OnSchedUtils.Internationalize(element, 'consumer_availability_booking_form_cancel')}
        </button>
      }
      <button 
        type="submit" 
        className='OnSchedBtn onsched-secondary-background-color onsched-primary-color'
      >
        {OnSchedUtils.Internationalize(element, 'consumer_availability_booking_form_submit')}
      </button>
    </div>
  )
}

export default SubmitRow
